
import { defineComponent, PropType } from 'vue'

const ROTATION_INTERVAL_MS = 7000

export default defineComponent({
  name: 'DegradedServiceBanner',
  props: {
    messages: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  },
  data () {
    return {
      currentIndex: 0,
      rotationTimer: null as number | null
    }
  },
  computed: {
    hasMessages (): boolean {
      return this.messages.length > 0
    },
    currentMessage (): string {
      return this.messages[this.currentIndex] ?? ''
    }
  },
  watch: {
    messages (newMessages: string[]) {
      if (this.currentIndex >= newMessages.length) {
        this.currentIndex = 0
      }
      this.setupRotation()
    }
  },
  mounted () {
    this.setupRotation()
  },
  beforeUnmount () {
    this.clearRotation()
  },
  methods: {
    setupRotation () {
      this.clearRotation()
      if (this.messages.length >= 2) {
        this.rotationTimer = window.setInterval(() => {
          this.currentIndex = (this.currentIndex + 1) % this.messages.length
        }, ROTATION_INTERVAL_MS)
      }
    },
    clearRotation () {
      if (this.rotationTimer !== null) {
        window.clearInterval(this.rotationTimer)
        this.rotationTimer = null
      }
    }
  }
})
